import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiSearch, FiMapPin } from "react-icons/fi";
import { BiArrowBack, BiStar } from "react-icons/bi";
import { MdOutlineGridView, MdViewList } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import apiKey from "../../../config/apiKey";

const HomeTeacherList = () => {
  const [isGridView, setIsGridView] = useState(true);
  const [lessons, setLessons] = useState([]);
  const [error, setError] = useState(null); // Track error state
  const student = JSON.parse(localStorage.getItem("edo-student"));
  const [loading, setLoading] = useState(true); // Add loading state
  useEffect(() => {
    setLoading(true); // Start loading before data fetch
    axios
      .get(`${apiKey}/api/edolutions/student/show-data`, {
        headers: {
          Authorization: `Bearer ${student?.token}`,
        },
      })
      .then((response) => {
        if (response.data && response.data.data) {
          setLessons(response.data.data);
          // console.log(response.data)
        } else {
          setError("No Teacher found related to your selected subject");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError("No Teacher found related to your selected subject");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [student?.token]);

  const toggleView = () => {
    setIsGridView((prevState) => !prevState);
  };
  const navigate = useNavigate();

  return (
    <div className="relative flex flex-col break-words w-full mb-6 shadow-lg bg-white rounded-lg p-8 border-0">
      <div
        className="flex  gap-2 items-center cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <BiArrowBack className="h-5 w-5" />
        <p className="text-[14px]">Back</p>
      </div>
      <div className="flex flex-wrap border-b-2 pb-5 items-center mt-5 justify-between">
        <div>
          <p className="text-2xl font-semibold ">Find Teachers</p>
          <p className="text-sm font-normal mt-2 ">Home Tuition</p>
        </div>
        <div className="flex flex-wrap justify-center md:space-y-0 space-y-5 items-center">
          <div className="relative border shadow-md rounded-md flex items-center  px-5 py-2">
            <FiSearch className="h-5 w-5 absolute  text-black" />{" "}
            <input
              type="text"
              className="outline-none pl-8"
              placeholder="Search"
              name=""
              id=""
            />
          </div>
        </div>
      </div>
      <div className="flex justify-start mt-5 mb-5 gap-3 ">
        <button onClick={toggleView}>
          <MdOutlineGridView className="h-8 w-8" />
        </button>

        <button onClick={toggleView}>
          <MdViewList className="h-8 w-8" />
        </button>
      </div>

      {loading ? (
        <div>
          <div colSpan="9" className="py-5 px-1 text-center">
            <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
              <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
              <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">
                Cabil...
              </p>
            </div>
          </div>
        </div>
      ) : lessons.length === 0 ? (
        <div>
          <div colSpan="9" className="py-5 px-1 text-center">
            <p className="text-gray-500">{error}</p>
          </div>
        </div>
      ) : (
        <div
          className={
            isGridView
              ? "flex flex-wrap justify-center gap-6 mt-5"
              : "gap-6 flex flex-col justify-center items-center mt-5 cursor-pointer"
          }
        >
          {lessons.map((teacher) => (
            <NavLink to={`../homeTeacherPortfolio/${teacher.user_id}`}>
              <div
                key={teacher.id}
                className="bg-white shadow-md w-56 rounded-lg h-full overflow-hidden flex flex-col justify-start pt-1  items-center cursor-pointer"
              >
                <img
                  src={
                    teacher.photo
                      ? `${apiKey}/userProfile/${teacher.photo}`
                      : `${apiKey}/userProfile/87654321.png`
                  }
                  alt={teacher.name || "Teacher profile picture"}
                  className="rounded-full border w-24 h-24"
                />

                <div className="p-4 text-center">
                  <h3 className="text-lg font-semibold capitalize ">
                    {teacher.name}
                  </h3>
                  <p className="text-sm text-gray-600 font-normal">
                    {teacher.subjects}
                  </p>
                  <p className="text-xs text-gray-500 font-normal mt-2">
                    Rs.{teacher.home_charges}/ Per Hour{" "}
                  </p>
                  <div className="flex items-center justify-center mt-2">
                    <BiStar className="h-4 w-4 fill-current text-yellow-500" />
                    <BiStar className="h-4 w-4 fill-current text-yellow-500" />
                    <BiStar className="h-4 w-4 fill-current text-yellow-500" />
                  </div>
                  <div className="flex items-center justify-center mt-2">
                    <div className="w-1/8 flex items-center justify-start ">
                    <FiMapPin className="h-4 w-4 mr-1 text-gray-500" />
                    </div>
                    <div className="w-7/8">
                    <p className="text-xs  font-normal text-gray-600">
                      {teacher.location}
                    </p>
                    </div>
                  </div>
                </div>
              </div>
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default HomeTeacherList;
